export const FEEDBACK_URL =
  'https://stuzo.atlassian.net/servicedesk/customer/portal/16/group/25/create/138';

export const NO_DATA_PLACEHOLDER = 'N/A';
export const NO_DATA_PLACEHOLDER_DASH = '—';
export const YES_PLACEHOLDER = 'Yes';
export const NO_PLACEHOLDER = 'No';
